import React, {useState} from 'react';
import {Form} from "react-bootstrap";
import {useTranslation} from "react-i18next";
import {ErrorToast, SuccessToast} from "../../../shared/toasters/toasters";
import {useNavigate} from "react-router-dom";
import {AdminSpeakerSpecificationService} from "../service";
import CreateForm from "./CreateForm";
import {ISpeakerSpecification} from "../index";

const CreateSpecification = () => {
    const {t} = useTranslation();

    const navigate = useNavigate()
    const [state, setState] = useState<ISpeakerSpecification | null>({
        active: false,
        name: ''
    });


    const submitHandler = () => {
        AdminSpeakerSpecificationService.create(state as ISpeakerSpecification)
            .then(() => {
                SuccessToast(t(`speaker_specifications.successfully_created`));
                navigate('/admin/speaker-specification');
                setState(null);
            })
            .catch((error) => ErrorToast(error));
    };

    return (
        <div className="col-12">
            <Form
                onSubmit={(e) => {
                    e.preventDefault();
                    submitHandler();
                }}
            >
                <CreateForm state={state} setState={setState}/>
            </Form>
        </div>
    );
};

export default CreateSpecification;